/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateExploreMutationVariables = Types.Exact<{
  additionalFilters: Types.InputMaybe<
    | ReadonlyArray<Types.Scalars["ColumnFilter"]["input"]>
    | Types.Scalars["ColumnFilter"]["input"]
  >;
  name: Types.Scalars["String"]["input"];
  projectLanguage: Types.InputMaybe<Types.ProjectLanguage>;
  baseCellId: Types.InputMaybe<Types.Scalars["CellId"]["input"]>;
  sourceAppSessionId: Types.InputMaybe<Types.Scalars["AppSessionId"]["input"]>;
  disableHydration?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type CreateExploreMutation = {
  readonly __typename: "Mutation";
  readonly createExplore: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly currentDraft: {
      readonly __typename: "HexVersion";
      readonly id: c.HexVersionId;
    };
  };
};

export const CreateExploreDocument = /*#__PURE__*/ gql`
  mutation CreateExplore(
    $additionalFilters: [ColumnFilter!]
    $name: String!
    $projectLanguage: ProjectLanguage
    $baseCellId: CellId
    $sourceAppSessionId: AppSessionId
    $disableHydration: Boolean = false
  ) {
    createExplore(
      additionalFilters: $additionalFilters
      name: $name
      projectLanguage: $projectLanguage
      baseCellId: $baseCellId
      sourceAppSessionId: $sourceAppSessionId
      disableHydration: $disableHydration
    ) {
      id
      currentDraft {
        id
      }
    }
  }
`;
export type CreateExploreMutationFn = Apollo.MutationFunction<
  CreateExploreMutation,
  CreateExploreMutationVariables
>;

/**
 * __useCreateExploreMutation__
 *
 * To run a mutation, you first call `useCreateExploreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExploreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExploreMutation, { data, loading, error }] = useCreateExploreMutation({
 *   variables: {
 *      additionalFilters: // value for 'additionalFilters'
 *      name: // value for 'name'
 *      projectLanguage: // value for 'projectLanguage'
 *      baseCellId: // value for 'baseCellId'
 *      sourceAppSessionId: // value for 'sourceAppSessionId'
 *      disableHydration: // value for 'disableHydration'
 *   },
 * });
 */
export function useCreateExploreMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateExploreMutation,
    CreateExploreMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateExploreMutation,
    CreateExploreMutationVariables
  >(CreateExploreDocument, options);
}
export type CreateExploreMutationHookResult = ReturnType<
  typeof useCreateExploreMutation
>;
export type CreateExploreMutationResult =
  Apollo.MutationResult<CreateExploreMutation>;
export type CreateExploreMutationOptions = Apollo.BaseMutationOptions<
  CreateExploreMutation,
  CreateExploreMutationVariables
>;
